import { useEffect, useRef, useState } from "react";

export default function VideoBackground() {

  const videoRef = useRef(null);
  const [videoUrl, setVideoUrl] = useState("");

  useEffect(() => {

    fetch(
      "https://edunet.kmechengineering.com/root-engine1/api/get-animation?t=" + Date.now()
    )
      .then((response) => response.json())
      .then((data) => {

        console.log(data);

        if (data.status) {
          setVideoUrl(data.video_url + "?v=" + Date.now());
        }

      })
      .catch((error) => {
        console.log(error);
      });

  }, []);

  useEffect(() => {

    if (videoRef.current && videoUrl) {
      videoRef.current.load();
      videoRef.current.play().catch(() => {});
    }

  }, [videoUrl]);

  if (!videoUrl) {
    return null;
  }

  return (
    <div style={styles.wrapper}>
      <video
        key={videoUrl}
        ref={videoRef}
        autoPlay
        muted
        loop
        playsInline
        style={styles.video}
      >
        <source src={videoUrl} type="video/mp4" />
      </video>

      <div style={styles.overlay}></div>
    </div>
  );
}

const styles = {
  wrapper: {
    position: "fixed",
    inset: 0,
    zIndex: 0,
    overflow: "hidden",
  },

  video: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    opacity: 0.6,
    filter: "brightness(0.7)",
  },

  overlay: {
    position: "absolute",
    inset: 0,
    background: "rgba(0,0,0,0.4)",
  },
};